export default __webpack_public_path__ + "8732a4e1a52584781fc63c4c19d1b513.jpg";